'use strict';
const assert = require('assert');
const Partner = require('../partner');
const chai = require('chai');
const sdkConfiguration = require('../../configurations/sdk-configuration');

const expect = chai.expect;
const credentials = {
  domain: 'csDesarrollo.onmicrosoft.com',
  clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
  userName: 'app@csDesarrollo.onmicrosoft.com',
  password: 'Inn0vaci0n',
};
const fakeMpnId = '110030';
const fakeRequest = options => Promise.resolve(options);

/* eslint-disable no-undef, no-unused-vars */
describe('Partner', () => {
  it('Creates a correct instance of the class', (done) => {
    const partner = new Partner(credentials, fakeRequest, sdkConfiguration);
    expect(partner).to.have.property('requestManager');
    expect(partner.requestManager).to.have.property('requestConfigurationManager');
    expect(partner.requestManager).to.have.property('authConfiguration');
    expect(partner.requestManager.requestConfigurationManager).to.have.property('sdkConfiguration');
    expect(partner.requestManager.requestConfigurationManager).to.have.property('credentials');
    expect(partner.requestManager.requestConfigurationManager).to.have.property('request');
    expect(partner).to.have.property('paramsManager');
    expect(partner.paramsManager).to.have.property('pathParams');
    expect(partner.paramsManager).to.have.property('bodyParams');
    expect(partner.paramsManager).to.have.property('queryParams');
    done();
  });
  it('get, returns the partner profile', (done) => {
    const partner = new Partner(credentials, fakeRequest, sdkConfiguration);
    partner.byMPN(fakeMpnId).get().then((partnerProfile) => {
      assert(partnerProfile.method === 'GET');
      assert(partnerProfile.uri === 'https://api.partnercenter.microsoft.com/v1/profiles/mpn?mpnId=110030');
      assert(partnerProfile.headers.Accept === 'application/json');
      assert(partnerProfile.headers['Content-Type'] === 'application/json');
      expect(partnerProfile.headers).to.have.property('MS-RequestId');
      expect(partnerProfile.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('get, if the mpnId is not set return an erro', (done) => {
    const partner = new Partner(credentials, fakeRequest, sdkConfiguration);
    try {
      partner.get();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byMPN function, to set the mpnId');
      done();
    }
  });
});
